import { render, staticRenderFns } from "./PersonalPoint.vue?vue&type=template&id=8e2d940c&"
import script from "./PersonalPoint.vue?vue&type=script&lang=js&"
export * from "./PersonalPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports